module.exports = __webpack_public_path__ + "img/logo_h.10311c34.png";